import React, { useEffect, useState } from "react";
import RfmModalBase from "./RfmModalBase";

// El cliente ya esta en una sesion e-commerce (con su QR) y decidio cambiarse de mesa: aqui el cajero
// elige la mesa libre a la que se mueve. La sesion, el pedido y el QR que se le dio siguen siendo los
// mismos - ver moveSessionToTable en el backend.
export default function RfmMoveTableSessionModal({ open, onClose, fromTable, candidates, processing, onConfirm }) {
  const [targetId, setTargetId] = useState("");

  useEffect(() => {
    if (open) setTargetId("");
  }, [open]);

  return (
    <RfmModalBase
      open={open}
      title={`Mover de mesa${fromTable ? ` • Mesa ${fromTable.number}` : ""}`}
      onClose={onClose}
      footer={
        <div className="ord-footer">
          <button className="ord-btn ord-btn-secondary" type="button" onClick={onClose}>
            Cancelar
          </button>
          <button
            className="ord-btn ord-btn-primary"
            type="button"
            disabled={processing || !targetId}
            onClick={() => onConfirm?.(Number(targetId))}
          >
            <i className="bi bi-arrow-left-right" /> Mover
          </button>
        </div>
      }
    >
      <div className="ord-scope">
        <p className="ord-confirm-text">
          El cliente conserva su pedido y el mismo QR; la mesa actual queda libre.
        </p>
        {Array.isArray(fromTable?.table_orders) && fromTable.table_orders.length > 1 ? (
          <p className="ord-confirm-text">
            <strong>Esta mesa tiene {fromTable.table_orders.length} pedidos</strong> (por ejemplo, de dos QR): se mueven todos juntos a la mesa destino.
          </p>
        ) : null}

        <div className="ord-form-group">
          <label className="ord-form-label">Mesa destino (solo mesas libres)</label>
          <select
            className="ord-form-input"
            value={targetId}
            onChange={(e) => setTargetId(e.target.value)}
          >
            <option value="">Selecciona una mesa...</option>
            {(candidates || []).map((t) => (
              <option key={t.id} value={t.id}>{t.label}</option>
            ))}
          </select>
          {(candidates || []).length === 0 ? (
            <small className="ord-confirm-text">No hay mesas libres disponibles.</small>
          ) : null}
        </div>
      </div>
    </RfmModalBase>
  );
}
